export const environment = {
  production: false,
  apiUrl: 'https://sportiq-main-api.digi4dev.ma',
  baseDomain: 'sportiq-main.digi4dev.ma',
  devFederationSlug: 'frmtt',
  version: '1.0.0'
};
